const getOrderOriginalRefNumber = ({ orderInsuranceParam, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (orderInsuranceParam && insurance) {
    const activeOrderInsuranceParam = orderInsuranceParam.find(item => item['Insurance ID'] === insurance.ID);
    return activeOrderInsuranceParam ? activeOrderInsuranceParam['Original Ref Number'] : null;
  }
  return null;
};

export default getOrderOriginalRefNumber;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderOriginalRefNumber.js